import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=8fcaf97a&scoped=true"
import script from "./ButtonBack.vue?vue&type=script&lang=js"
export * from "./ButtonBack.vue?vue&type=script&lang=js"
import style0 from "./ButtonBack.vue?vue&type=style&index=0&id=8fcaf97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcaf97a",
  null
  
)

export default component.exports